/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ln_term_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Term (years)`)
};

const es_ln_term_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plazo (años)`)
};

const de_ln_term_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laufzeit (Jahre)`)
};

const nl_ln_term_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Looptijd (jaren)`)
};

const fr_ln_term_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée (années)`)
};

const it_ln_term_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata (anni)`)
};

const pt_br2_ln_term_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prazo (anos)`)
};

const pt_ln_term_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prazo (anos)`)
};

const ja_ln_term_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「期間 (年)」`)
};

const zh_ln_term_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期限（年）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ln_term_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ln_term_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ln_term_label", locale)
	if (locale === "en") return en_ln_term_label(inputs)
	if (locale === "es") return es_ln_term_label(inputs)
	if (locale === "de") return de_ln_term_label(inputs)
	if (locale === "nl") return nl_ln_term_label(inputs)
	if (locale === "fr") return fr_ln_term_label(inputs)
	if (locale === "it") return it_ln_term_label(inputs)
	if (locale === "pt-BR") return pt_br2_ln_term_label(inputs)
	if (locale === "pt") return pt_ln_term_label(inputs)
	if (locale === "ja") return ja_ln_term_label(inputs)
	return zh_ln_term_label(inputs)
};